<template>
  <div>
    <div class="el-section">
      <div class="emeraldraws">
        <svg
          width="377px"
          height="400px"
          viewBox="0 0 377 400"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          >
          <title>box-guy</title>
          <g id="box-guy" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <polygon
              id="pgm-clear"
              fill-rule="nonzero"
              points="230.211 156.059 307.125 149.547 302.724 212.732 235.843 217.132"
            />
            <path
              d="M305.718,150.955 L301.318,211.5 L236.901,215.724 L231.445,157.115 L305.718,150.955 Z M308.71,147.963 L228.98,154.827 L234.789,218.54 L303.958,213.964 L308.71,147.963 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M259.606,203.404 C258.902,203.404 258.373,202.876 258.373,202.172 L256.085,184.219 L247.989,181.579 C247.285,181.403 246.933,180.523 247.109,179.995 C247.285,179.291 248.165,178.939 248.693,179.115 L258.198,182.283 L260.662,201.82 C261.014,202.524 260.486,203.228 259.606,203.404 C259.782,203.404 259.782,203.404 259.606,203.404 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M225.987,44.8247 C237.251,41.3046 270.164,32.6804 298.148,79.4974 C326.309,126.314 308.533,166.619 308.533,166.619 L224.227,162.395 C224.227,162.395 221.587,114.874 214.019,84.4255 C212.435,77.9134 208.035,50.4568 225.987,44.8247 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M162.277,153.595 C172.661,159.755 178.117,175.243 178.117,175.243 L168.965,177.532 C168.965,177.532 162.101,169.083 156.644,169.083 C151.188,169.083 162.277,153.595 162.277,153.595 Z"
              id="pgm-clear"
              fill-rule="nonzero"
            />
            <path
              d="M168.261,178.939 L167.733,178.235 C165.973,175.947 160.341,170.315 156.468,170.315 C154.884,170.315 154.18,169.435 154.004,168.907 C152.244,165.563 158.404,156.587 161.22,152.715 L161.925,151.659 L162.98,152.187 C173.541,158.523 179.173,173.835 179.349,174.363 L179.877,175.771 L168.261,178.939 Z M156.292,167.675 C156.292,167.675 156.468,167.675 156.292,167.675 C161.572,167.675 167.381,173.835 169.317,175.947 L176.181,174.187 C174.597,170.491 170.021,160.459 162.452,155.355 C158.756,160.987 155.94,166.443 156.292,167.675 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <polygon
              id="pgm-clear"
              fill-rule="nonzero"
              points="222.645 224.525 92.93 224.525 89.762 219.245 123.378 198.828 184.276 161.692 206.98 198.828"
            />
            <path
              d="M183.748,163.451 L206.1,200.236 L220.181,223.117 L93.81,223.117 L91.698,219.597 L122.147,200.94 L183.748,163.451 Z M184.628,159.931 L120.739,198.828 L88.002,218.893 L92.226,225.933 L224.933,225.933 L208.564,199.004 L184.628,159.931 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M129.89,211.853 C129.362,211.853 129.01,211.677 128.834,211.149 C128.482,210.445 128.658,209.741 129.362,209.389 L176.883,180.348 C177.587,179.996 178.291,180.172 178.643,180.7 C178.995,181.404 178.819,182.108 178.115,182.46 L130.594,211.501 C130.242,211.853 130.066,211.853 129.89,211.853 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M138.339,225.933 C137.811,225.933 137.459,225.757 137.283,225.229 C136.931,224.525 137.107,223.821 137.811,223.469 L185.332,194.428 C186.036,194.076 186.74,194.253 187.092,194.781 C187.444,195.485 187.268,196.189 186.564,196.541 L139.043,225.581 C138.867,225.933 138.691,225.933 138.339,225.933 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M164.741,155.355 C163.685,152.187 162.805,147.787 166.149,142.683 C155.061,141.275 144.148,140.219 133.06,139.691 C126.548,155.355 128.66,170.668 131.652,184.572 C136.932,208.685 145.028,201.468 145.028,201.468 C145.028,201.468 149.604,204.637 154.18,199.18 C154.18,199.18 160.869,203.404 163.157,197.244 C165.445,191.084 155.589,181.756 158.933,175.596 C159.813,174.012 160.869,172.604 161.925,171.196"
              id="pgm-clear"
              fill-rule="nonzero"
            />
            <path
              d="M142.037,203.756 C141.509,203.756 140.981,203.756 140.277,203.404 C136.053,201.996 132.709,195.836 130.245,184.747 C127.077,170.315 125.141,154.827 131.653,139.162 L132.005,138.282 L132.885,138.282 C144.325,138.81 155.59,140.043 166.15,141.275 L168.262,141.451 L167.206,143.211 C164.214,147.787 164.918,151.659 165.974,154.827 C166.15,155.531 165.798,156.235 165.094,156.587 C164.39,156.763 163.686,156.411 163.334,155.707 C162.278,152.539 161.398,148.491 163.862,143.739 C154.358,142.507 144.149,141.451 133.765,140.923 C127.957,155.707 129.893,170.315 132.885,184.219 C135.701,197.244 139.221,200.236 141.157,200.94 C142.741,201.468 143.973,200.412 144.149,200.412 L144.853,199.708 L145.733,200.236 C146.085,200.412 149.43,202.524 153.126,198.124 L153.83,197.244 L154.886,197.772 C155.59,198.3 158.054,199.356 159.814,198.828 C160.694,198.476 161.398,197.772 161.926,196.54 C162.806,194.076 161.222,190.732 159.638,187.212 C157.702,182.987 155.59,178.411 157.702,174.715 C158.582,172.955 159.814,171.547 160.87,170.139 C161.398,169.611 162.102,169.435 162.806,169.963 C163.334,170.491 163.51,171.195 162.982,171.899 C161.926,173.131 160.87,174.539 159.99,176.123 C158.582,178.763 160.342,182.635 161.926,186.332 C163.686,190.204 165.446,194.252 164.214,197.596 C163.51,199.532 162.278,200.94 160.518,201.468 C158.23,202.172 155.59,201.292 154.358,200.764 C150.838,204.284 147.142,203.932 145.03,203.052 C144.326,203.404 143.445,203.756 142.037,203.756 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M145.732,178.236 C144.324,184.748 148.196,190.204 151.892,195.132 C152.596,196.012 154.004,195.132 153.3,194.252 C149.78,189.852 146.084,184.748 147.316,178.588 C147.844,177.532 146.084,177.18 145.732,178.236 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M136.758,183.691 C137.462,189.499 138.518,195.484 143.799,198.828 C144.679,199.356 145.559,197.772 144.679,197.244 C139.927,194.427 139.222,188.619 138.518,183.691 C138.342,182.459 136.582,182.459 136.758,183.691 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M126.547,156.939 C126.371,124.378 139.043,78.2653 171.604,56.7929 C213.845,28.8083 243.941,42.0086 243.941,42.0086 L243.941,80.7294 C243.941,80.7294 207.156,65.4171 184.804,101.498 C167.732,128.954 173.54,148.139 173.54,148.139 L126.547,156.939 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M213.67,79.1454 C212.966,79.1454 212.438,78.6173 212.438,77.9133 L211.206,67.7051 C211.03,67.0011 211.558,66.2971 212.438,66.2971 C213.142,66.2971 213.846,66.6491 213.846,67.5292 L215.078,77.7374 C215.078,78.4414 214.55,79.1454 213.67,79.1454 C213.846,79.1454 213.67,79.1454 213.67,79.1454 Z"
              id="pgm-clear"
              fill-rule="nonzero"
            />
            <polygon
              id="pgm-brand"
              fill-rule="nonzero"
              points="60.0174 87.9451 16.8965 114.698 70.7537 225.756 113.875 199.179"
            />
            <path
              d="M188.322,144.795 C187.618,144.795 187.09,144.267 186.914,143.563 L186.738,130.891 C186.738,130.187 187.266,129.483 187.97,129.483 C188.674,129.483 189.378,130.011 189.378,130.715 L189.554,143.387 C189.73,144.091 189.202,144.795 188.322,144.795 C188.498,144.795 188.322,144.795 188.322,144.795 Z"
              id="pgm-brand"
              fill-rule="nonzero"
            />
            <path
              d="M196.069,150.075 C195.893,150.075 195.717,150.075 195.541,149.899 C194.837,149.547 194.661,148.843 194.837,148.139 L199.237,138.635 C199.589,137.931 200.293,137.755 200.997,137.931 C201.701,138.283 201.877,138.987 201.701,139.691 L197.301,149.195 C197.125,149.723 196.597,150.075 196.069,150.075 Z"
              id="pgm-brand"
              fill-rule="nonzero"
            />
            <path
              d="M102.084,147.962 C98.212,147.962 93.636,146.554 89.588,141.802 C88.532,140.394 87.4757,138.986 86.4196,137.578 C82.3715,131.594 79.3796,127.37 69.3474,132.122 C68.6433,132.474 67.9393,132.122 67.5873,131.418 C67.2353,130.714 67.5873,130.01 68.2913,129.658 C80.2595,124.026 84.4836,130.186 88.532,135.994 C89.412,137.402 90.468,138.81 91.524,140.042 C98.916,148.842 108.244,143.914 108.596,143.738 C109.3,143.386 110.004,143.562 110.356,144.266 C110.708,144.97 110.532,145.674 109.828,146.026 C110.004,146.026 106.66,147.962 102.084,147.962 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M99.795,156.939 C95.923,156.939 91.347,155.531 87.2987,150.779 C86.2427,149.371 85.1867,147.963 84.1307,146.554 C80.0826,140.57 77.0905,136.346 67.0583,141.098 C66.3543,141.45 65.6503,141.098 65.2982,140.394 C64.9462,139.69 65.2983,138.986 66.0023,138.634 C77.9706,133.002 82.1946,138.986 86.2427,144.971 C87.1227,146.379 88.179,147.787 89.235,149.019 C96.627,157.819 105.955,152.891 106.307,152.715 C107.011,152.363 107.715,152.539 108.067,153.243 C108.419,153.947 108.243,154.651 107.539,155.003 C107.715,155.003 104.195,156.939 99.795,156.939 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <polygon
              id="pgm"
              fill-rule="nonzero"
              points="82.7202 77.9131 78.4961 96.0414 95.568 89.7054"
            />
            <path
              d="M76.7363,98.1539 L81.8405,75.4495 L98.033,90.2337 L76.7363,98.1539 Z M83.4246,80.3775 L80.4325,93.9299 L93.105,89.1777 L83.4246,80.3775 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <polygon
              id="pgm-clear"
              fill-rule="nonzero"
              points="22.5229 153.685 12.1934 143.355 1.8638 153.685 12.1934 164.014"
            />
            <path
              d="M12.1443,165.739 L0,153.595 L12.1443,141.451 L24.2885,153.595 L12.1443,165.739 Z M3.696,153.595 L12.1443,162.043 L20.5925,153.595 L12.1443,145.147 L3.696,153.595 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M192.196,216.781 C191.844,216.781 191.668,216.605 191.316,216.429 L185.684,211.5 C185.156,210.972 184.98,210.268 185.508,209.564 C186.036,209.036 186.74,208.86 187.444,209.388 L193.076,214.316 C193.604,214.845 193.78,215.549 193.252,216.253 C192.9,216.605 192.548,216.781 192.196,216.781 Z"
              id="pgm-brand"
              fill-rule="nonzero"
            />
            <path
              d="M109.298,117.339 C109.122,117.339 108.946,117.339 108.77,117.163 C108.066,116.811 107.89,116.107 108.242,115.402 L114.051,103.61 C114.403,102.906 115.107,102.73 115.811,103.082 C116.515,103.434 116.691,104.138 116.339,104.842 L110.53,116.635 C110.354,117.163 109.826,117.339 109.298,117.339 Z"
              id="pgm-brand"
              fill-rule="nonzero"
            />
            <path
              d="M234.79,141.099 C234.438,141.099 234.086,140.923 233.91,140.747 C233.382,140.219 233.382,139.339 233.91,138.811 L244.998,127.723 C245.526,127.195 246.406,127.195 246.934,127.723 C247.462,128.251 247.462,129.131 246.934,129.659 L235.846,140.747 C235.318,140.923 235.142,141.099 234.79,141.099 Z"
              id="pgm-brand"
              fill-rule="nonzero"
            />
            <path
              d="M213.67,172.427 C212.966,172.427 212.438,171.899 212.438,171.195 L211.734,164.507 C211.734,163.803 212.262,163.099 212.966,163.099 C213.67,163.099 214.374,163.627 214.374,164.331 L215.078,171.019 C215.078,171.723 214.55,172.427 213.67,172.427 Z"
              id="pgm-brand"
              fill-rule="nonzero"
            />
            <polygon
              id="pgm-clear"
              fill-rule="nonzero"
              points="252.74 154.828 261.54 147.963 263.3 159.932"
            />
            <polygon
              id="pgm-brand"
              fill-rule="nonzero"
              points="285.124 225.756 70.752 225.756 70.752 399.823 285.124 399.823"
            />
            <polygon
              id="pgm-brand"
              fill-rule="nonzero"
              points="327.718 372.895 285.125 400 285.125 225.756 327.718 198.827"
            />
            <polygon
              id="pgm-clear"
              fill-rule="nonzero"
              points="194.485 334.351 72.1621 334.351 72.1621 398.592 194.485 398.592"
            />
            <path
              d="M193.075,335.583 L193.075,397.184 L73.392,397.184 L73.392,335.583 L193.075,335.583 Z M195.715,332.943 L70.752,332.943 L70.752,399.824 L195.715,399.824 L195.715,332.943 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M156.995,398.239 C156.643,398.239 156.467,398.239 156.291,398.063 L72.6895,336.99 C72.1614,336.638 71.9854,335.758 72.3374,335.23 C72.6894,334.702 73.5695,334.526 74.0975,334.878 L157.699,395.951 C158.227,396.303 158.403,397.183 158.051,397.711 C157.875,398.063 157.347,398.239 156.995,398.239 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M109.295,398.239 C108.943,398.239 108.415,398.063 108.239,397.711 C107.887,397.183 107.887,396.303 108.591,395.951 L191.489,334.878 C192.017,334.526 192.897,334.526 193.249,335.23 C193.601,335.758 193.601,336.638 192.897,336.99 L109.999,398.063 C109.823,398.239 109.647,398.239 109.295,398.239 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M285.125,391.551 C284.421,391.551 283.717,391.023 283.717,390.143 L283.717,237.9 C283.717,237.196 284.245,236.492 285.125,236.492 C286.005,236.492 286.533,237.02 286.533,237.9 L286.533,390.143 C286.533,391.023 286.005,391.551 285.125,391.551 Z"
              id="pgm-clear"
              fill-rule="nonzero"
            />
            <path
              d="M136.225,225.756 L136.225,226.108 C136.225,271.693 107.185,293.517 70.752,294.749 L70.752,225.932 L136.225,225.932 L136.225,225.756 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <polygon
              id="pgm"
              fill-rule="nonzero"
              points="118.273 285.597 103.312 297.741 121.793 305.837"
            />
            <polygon
              id="pgm-clear"
              fill-rule="nonzero"
              points="259.779 264.301 154.705 264.301 154.705 274.861 259.779 274.861"
            />
            <path
              d="M217.715,294.749 L199.411,294.749 C197.299,294.749 195.715,292.989 195.715,291.053 C195.715,288.941 197.475,287.357 199.411,287.357 L217.715,287.357 C219.827,287.357 221.411,289.117 221.411,291.053 C221.587,292.989 219.827,294.749 217.715,294.749 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M237.78,294.749 L231.62,294.749 C229.508,294.749 227.924,292.989 227.924,291.053 C227.924,288.941 229.684,287.357 231.62,287.357 L237.78,287.357 C239.892,287.357 241.476,289.117 241.476,291.053 C241.652,292.989 239.892,294.749 237.78,294.749 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M255.907,294.749 L249.747,294.749 C247.635,294.749 246.051,292.989 246.051,291.053 C246.051,288.941 247.811,287.357 249.747,287.357 L255.907,287.357 C258.019,287.357 259.603,289.117 259.603,291.053 C259.603,292.989 258.019,294.749 255.907,294.749 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <polygon
              id="pgm"
              fill-rule="nonzero"
              points="343.911 251.276 337.047 251.276 337.047 326.078 343.911 326.078"
            />
            <polygon
              id="pgm"
              fill-rule="nonzero"
              points="327.721 198.828 303.961 213.965 285.304 225.933 70.7559 225.933 113.173 198.828 123.381 198.828 89.764 219.245 92.932 224.525 222.647 224.525 206.983 198.828"
            />
            <path
              d="M223.35,224.525 C236.198,216.604 253.622,212.556 275.095,212.556 C281.431,212.556 288.119,212.908 295.159,213.612 C297.271,213.788 299.031,214.14 300.615,214.493 L284.775,224.525 L223.35,224.525 Z"
              id="pgm-clear"
              fill-rule="nonzero"
            />
            <path
              d="M275.094,211.324 L275.094,213.964 C281.43,213.964 288.119,214.316 294.983,215.02 C295.687,215.02 296.391,215.196 297.095,215.196 L284.599,223.116 L228.453,223.116 C240.598,216.956 256.262,213.788 275.094,213.788 L275.094,211.324 Z M275.094,211.324 C253.622,211.324 233.734,215.196 218.949,225.932 L285.303,225.932 L303.959,214.14 C301.847,213.436 299.031,212.908 295.335,212.38 C288.471,211.676 281.782,211.324 275.094,211.324 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M60.1934,181.756 L60.0174,181.756 L38.721,177.884 C38.0169,177.708 37.489,177.004 37.665,176.3 C37.841,175.596 38.5449,175.068 39.2489,175.244 L60.5455,179.116 C61.2495,179.292 61.7774,179.996 61.6014,180.7 C61.4254,181.228 60.8974,181.756 60.1934,181.756 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M47.6977,190.38 L47.5217,190.38 C46.8177,190.204 46.2898,189.5 46.4658,188.796 L50.3378,167.5 C50.5138,166.796 51.2178,166.268 51.9218,166.444 C52.6258,166.62 53.1538,167.324 52.9778,168.028 L49.1058,189.324 C48.7538,189.852 48.2257,190.38 47.6977,190.38 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M213.669,211.148 C221.932,211.148 228.63,204.45 228.63,196.187 C228.63,187.925 221.932,181.227 213.669,181.227 C205.407,181.227 198.709,187.925 198.709,196.187 C198.709,204.45 205.407,211.148 213.669,211.148 Z"
              id="pgm-clear"
              fill-rule="nonzero"
            />
            <path
              d="M213.667,212.556 C204.691,212.556 197.299,205.164 197.299,196.188 C197.299,187.211 204.691,179.819 213.667,179.819 C222.643,179.819 230.036,187.211 230.036,196.188 C230.036,205.164 222.643,212.556 213.667,212.556 Z M213.667,182.459 C206.099,182.459 199.939,188.619 199.939,196.188 C199.939,203.756 206.099,209.916 213.667,209.916 C221.235,209.916 227.396,203.756 227.396,196.188 C227.396,188.619 221.235,182.459 213.667,182.459 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <polygon
              id="pgm-clear"
              fill-rule="nonzero"
              points="95.396 166.795 92.58 198.828 118.981 186.86"
            />
            <path
              d="M91.172,200.94 L94.34,164.155 L121.445,187.212 L91.172,200.94 Z M96.452,169.435 L94.164,196.716 L116.692,186.508 L96.452,169.435 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <polygon
              id="pgm-brand"
              fill-rule="nonzero"
              points="343.91 130.891 301.493 157.819 285.125 226.109 327.718 199.18"
            />
            <path
              d="M290.052,224.173 C289.7,224.173 289.172,223.996 288.996,223.644 C288.644,223.116 288.82,222.236 289.348,221.884 L322.084,201.116 C322.612,200.764 323.492,200.94 323.844,201.468 C324.196,201.996 324.02,202.876 323.492,203.228 L290.756,223.996 C290.58,223.996 290.228,224.173 290.052,224.173 Z"
              id="pgm-clear"
              fill-rule="nonzero"
            />
            <path
              d="M246.756,40.2485 C297.445,38.1365 344.614,52.5687 360.982,72.9852 C378.935,95.3376 369.782,139.339 347.782,150.779 C342.326,153.595 336.166,154.299 332.822,155.883 C322.613,160.635 320.325,160.107 316.981,157.467 C316.981,157.467 308.533,162.747 306.069,156.235 C306.069,156.235 302.901,164.507 296.917,162.395 C291.109,160.283 298.149,143.915 314.165,135.466 C330.182,127.018 338.454,105.898 329.478,93.2256 C320.325,80.5533 264.884,65.065 264.884,65.065 L246.756,40.2485 Z"
              id="pgm-clear"
              fill-rule="nonzero"
            />
            <path
              d="M298.852,164.155 C298.148,164.155 297.444,163.979 296.564,163.803 C294.804,163.275 293.748,161.691 293.572,159.579 C293.044,152.891 301.14,140.923 313.637,134.411 C322.261,129.835 328.949,121.21 331.237,111.882 C332.821,105.194 331.765,98.8578 328.421,94.1057 C319.621,81.9615 265.236,66.6491 264.532,66.4731 L264.18,66.2972 L244.115,39.0166 L246.579,38.8405 C296.388,36.7285 344.789,50.8088 362.038,72.1053 C370.838,83.1935 374.006,100.266 370.31,117.866 C366.966,133.707 358.87,146.379 348.485,151.835 C345.141,153.595 341.621,154.475 338.629,155.355 C336.517,155.883 334.757,156.411 333.525,156.939 C323.845,161.515 320.677,161.515 316.981,158.875 C315.397,159.755 311.701,161.339 308.709,160.283 C307.829,159.931 306.948,159.403 306.42,158.699 C304.836,161.515 302.196,164.155 298.852,164.155 Z M265.94,64.0091 C271.572,65.5932 321.909,80.2014 330.709,92.5216 C334.581,97.8018 335.637,104.842 333.877,112.41 C331.589,122.442 324.197,131.771 314.869,136.699 C302.724,143.035 295.86,154.123 296.212,159.403 C296.388,160.987 297.092,161.163 297.444,161.339 C302.02,162.923 304.837,156.059 304.837,155.883 L306.069,152.715 L307.3,155.883 C307.653,157.115 308.357,157.819 309.413,157.995 C311.701,158.699 315.221,157.115 316.277,156.411 L317.157,155.883 L317.861,156.411 C320.501,158.523 322.261,159.403 332.293,154.651 C333.877,153.947 335.637,153.419 337.749,152.891 C340.741,152.011 344.085,151.131 347.077,149.547 C356.758,144.443 364.502,132.475 367.67,117.514 C371.19,100.618 368.374,84.4255 359.926,73.8653 C343.557,53.4489 297.268,40.0725 249.219,41.4806 L265.94,64.0091 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M329.653,93.226 C334.581,99.9141 334.406,109.242 330.885,117.514 C342.326,121.739 359.574,125.787 370.662,130.891 C379.286,112.762 379.462,86.1859 365.91,71.9296 C339.51,44.649 297.621,37.9608 246.932,40.0729 L270.868,81.4337 C270.692,81.4337 320.501,80.7297 329.653,93.226 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M316.807,140.747 C312.231,143.915 308.535,147.963 306.071,152.891 C305.543,153.947 307.127,154.827 307.655,153.771 C310.119,149.019 313.463,145.147 317.863,142.331 C318.567,141.627 317.687,140.219 316.807,140.747 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M326.486,144.443 C322.79,147.083 319.974,150.427 317.862,154.475 C317.334,155.531 318.918,156.412 319.446,155.355 C321.382,151.659 324.022,148.491 327.366,146.027 C328.246,145.323 327.366,143.915 326.486,144.443 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M295.335,84.2496 C295.159,84.2496 295.159,84.2496 294.983,84.2496 L287.767,81.9615 C287.063,81.7855 286.711,81.0815 286.887,80.3775 C287.063,79.6735 287.767,79.3215 288.471,79.4975 L295.687,81.7855 C296.391,81.9615 296.743,82.6656 296.567,83.3696 C296.391,83.8976 295.863,84.2496 295.335,84.2496 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M52.4461,307.07 C52.0941,307.07 51.7421,306.894 51.5661,306.718 L23.5816,278.733 C23.0535,278.205 23.0535,277.325 23.5816,276.797 C24.1096,276.269 24.9895,276.269 25.5176,276.797 L53.5022,304.782 C54.0302,305.31 54.0302,306.19 53.5022,306.718 C53.1502,307.07 52.7981,307.07 52.4461,307.07 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M24.4616,307.07 C24.1096,307.07 23.7576,306.894 23.5816,306.718 C23.0535,306.19 23.0535,305.31 23.5816,304.782 L51.5661,276.797 C52.0941,276.269 52.9742,276.269 53.5022,276.797 C54.0302,277.325 54.0302,278.205 53.5022,278.733 L25.5176,306.718 C25.1655,307.07 24.8136,307.07 24.4616,307.07 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M52.4473,331.182 L24.4628,331.182 C23.7588,331.182 23.0547,330.654 23.0547,329.774 C23.0547,328.894 23.5828,328.366 24.4628,328.366 L52.4473,328.366 C53.1513,328.366 53.8553,328.894 53.8553,329.774 C53.8553,330.654 53.1513,331.182 52.4473,331.182 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M253.268,20.8875 C252.74,19.6555 252.036,18.4234 251.156,17.1913 C251.156,17.1913 251.156,17.1914 251.156,17.0154 C243.06,5.39914 228.276,1.87907 217.892,9.09522 C212.963,12.6153 210.147,18.0714 209.443,24.0555 C208.563,30.5677 211.027,37.2558 213.668,43.0639 C219.652,56.4402 233.204,62.4243 246.932,50.9841 C249.924,48.52 252.212,45.352 253.796,41.6559 C259.076,40.5999 262.244,36.7278 262.772,31.9757 C263.301,26.5196 259.252,20.3595 253.268,20.8875 Z"
              id="pgm-clear"
              fill-rule="nonzero"
            />
            <path
              d="M232.149,58.3764 C230.741,58.3764 229.333,58.2004 227.925,57.8484 C221.413,56.2644 215.605,51.1602 212.261,43.5921 C209.797,38.1359 206.981,30.9198 208.037,23.8796 C208.917,17.0155 212.085,11.3834 217.013,8.03929 C221.941,4.69522 228.101,3.28719 234.261,4.51921 C241.301,5.75124 247.814,10.1514 252.214,16.3115 C252.918,17.3675 253.622,18.4236 254.15,19.6556 C256.614,19.6556 258.902,20.7116 260.838,22.6477 C263.302,25.1117 264.534,28.8078 264.006,32.3279 C263.302,37.784 259.782,41.832 254.678,43.0641 C253.094,46.5841 250.63,49.7522 247.638,52.2163 C242.533,56.2644 237.253,58.3764 232.149,58.3764 Z M229.861,6.63128 C225.813,6.63128 221.765,7.8633 218.421,10.1514 C214.021,13.1434 211.381,18.0715 210.501,24.2316 C209.621,30.5678 212.085,37.08 214.549,42.5361 C217.541,49.2242 222.645,53.9763 228.453,55.3843 C234.085,56.6163 240.069,54.8563 245.878,50.1042 C248.694,47.8162 250.982,44.8241 252.39,41.304 L252.742,40.6 L253.446,40.424 C257.846,39.544 260.838,36.3759 261.366,31.7998 C261.718,29.1597 260.662,26.1677 258.902,24.2316 C257.846,23.1756 256.086,21.9436 253.446,22.1196 L252.566,22.1196 L252.214,21.2396 C251.51,19.8315 250.982,18.7755 250.278,17.7195 C246.23,11.9114 240.421,8.03937 233.909,6.80735 C232.501,6.80735 231.093,6.63128 229.861,6.63128 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M229.959,33.7478 C230.482,32.9287 230.243,31.8404 229.423,31.317 C228.604,30.7935 227.516,31.0332 226.993,31.8522 C226.469,32.6712 226.709,33.7595 227.528,34.283 C228.347,34.8064 229.435,34.5668 229.959,33.7478 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M222.119,46.2326 C220.359,42.7126 219.127,39.0165 218.247,35.1444 C218.071,34.0884 219.831,33.7364 220.007,34.7924 C220.711,38.4885 221.943,42.0086 223.703,45.5287 C224.231,46.4087 222.647,47.2887 222.119,46.2326 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M247.989,33.5604 C248.341,29.5123 251.509,25.9923 255.733,25.4643 C256.789,25.2883 257.317,27.0483 256.085,27.2243 C252.741,27.5763 250.101,30.2163 249.749,33.5604 C249.573,34.7924 247.813,34.6164 247.989,33.5604 Z"
              id="pgm"
              fill-rule="nonzero"
            />
            <path
              d="M246.229,25.4641 C244.997,29.8642 239.365,23.8801 228.629,21.7681 C223.877,20.8881 203.636,27.9282 200.468,21.064 C195.716,11.0318 209.092,5.22366 217.716,8.91973 C216.836,5.22366 221.06,-0.232415 226.693,2.58364 C241.829,-4.98452 255.557,4.87174 253.797,21.7681 C253.797,21.9441 247.637,24.0561 246.229,25.4641 Z"
              id="pgm"
              fill-rule="nonzero"
            />
          </g>
        </svg>
      </div>
    </div>
    <div class="el-section">
      <h2 class="emd-text _size_subpage">{{$t('error.404.title')}}</h2>
    </div>
    <button
      class="emd-btn _color_primary _size_big"
      data-test="ctaErrorButton"
      @click="ctaClicked"
    >{{$t('error.404.link')}}</button>
  </div>
</template>

<script>

export default {
  name: 'Error404Pgm',
  methods: {
    ctaClicked () {
      this.$emit('ctaClicked')
    }
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "error": {
      "404": {
        "link": "Ir para home",
        "title": "Essa página não existe."
      }
    }
  },
  "en-US": {
    "error": {
      "404": {
        "link": "Go to home",
        "title": "This page does not exist."
      }
    }
  }
}
</i18n>

<style>
#pgm-brand {
  fill: #6045AF;
}
._mode_dark #pgm-brand {
  fill: #8267D3;
}
._mode_light #pgm-brand {
  fill: #6045AF;
}
#pgm {
  fill: #2B2B2B;
}
._mode_dark #pgm {
  fill: #ffffff;
}
._mode_light #pgm {
  fill: #2B2B2B;
}
#pgm-clear {
  fill: #FFFFFF;
}
._mode_dark #pgm-clear {
  fill: #272A2D;
}
._mode_light #pgm-clear {
  fill: #FFFFFF;
}
</style>
